(() => {
  'use strict';
  const bar = document.querySelector('[data-cn-mobile-compare]');
  if (!bar || bar.dataset.ready) return;
  bar.dataset.ready = 'true';
  const key = 'cn.shopify.compare.v1';
  const mobile = matchMedia('(max-width: 767px)');
  const countNode = bar.querySelector('[data-cn-selection-count="compare"]');
  const drawer = document.querySelector('[data-cn-comparison-drawer]');
  const root = document.documentElement;
  let frame;

  const count = () => {
    try {
      const entries = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(entries)) return 0;
      const unique = new Set(entries.filter(item => item && typeof item.handle === 'string' && typeof item.variantId === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(item.handle) && /^\d+$/.test(item.variantId)).map(item => item.handle + ':' + item.variantId));
      return Math.min(4, unique.size);
    } catch { return 0; }
  };
  const visible = node => {
    if (!node || node.closest('[hidden], [inert], [aria-hidden="true"], details:not([open])')) return false;
    const style = getComputedStyle(node);
    // A dialog can retain display:flex while its menu/drawer ancestor has
    // display:none. Only an actual rendered box represents an open overlay.
    return node.getClientRects().length > 0 && style.visibility !== 'hidden' && style.visibility !== 'collapse';
  };
  const overlayOpen = () => {
    if (document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile')) return true;
    return [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], [role="alertdialog"][aria-modal="true"], cart-drawer.active, cart-notification.active, #cart-notification.active, quick-add-modal[open], product-modal[open], modal-dialog[open]')].some(visible);
  };
  const typing = () => {
    const active = document.activeElement;
    return Boolean(active?.matches('textarea, select, input:not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="color"])') || active?.closest('[contenteditable="true"], [contenteditable=""]'));
  };
  const excludedPage = () => document.querySelector('[data-cn-tools="compare"]') || document.body.classList.contains('cn-newsletter-confirmed') || /\/account\/subscribe\/?$/.test(location.pathname);
  const revealFocus = () => {
    const target = document.activeElement;
    if (bar.hidden || !target || target === document.body || bar.contains(target) || target.closest('.cn-sticky-purchase') || !visible(target)) return;
    const focused = target.getBoundingClientRect(), fixed = bar.getBoundingClientRect();
    if (focused.height > 0 && focused.bottom > fixed.top - 12 && focused.top < window.innerHeight) window.scrollBy({ top: focused.bottom - fixed.top + 12, behavior: 'instant' });
  };
  const sync = () => {
    const total = count();
    if (countNode.textContent !== String(total)) countNode.textContent = String(total);
    if (countNode.hidden !== (total === 0)) countNode.hidden = total === 0;
    const keyboard = window.visualViewport && window.visualViewport.scale === 1 && window.innerHeight - window.visualViewport.height > 160;
    const show = Boolean(total && drawer && mobile.matches && !excludedPage() && !overlayOpen() && !typing() && !keyboard);
    if (bar.hidden === show) bar.hidden = !show;
    if (document.body.hasAttribute('data-cn-mobile-compare-active') !== show) document.body.toggleAttribute('data-cn-mobile-compare-active', show);
    const gap = document.body.hasAttribute('data-cn-sticky-purchase-active') ? 8 : 0;
    const space = show ? `${Math.ceil(bar.getBoundingClientRect().height) + gap}px` : '0px';
    if (root.style.getPropertyValue('--cn-mobile-compare-space') !== space) root.style.setProperty('--cn-mobile-compare-space', space);
    revealFocus();
  };
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = null; sync(); });
  };
  document.addEventListener('cn:compare-change', schedule);
  // Native dialog focus restoration runs immediately after the close event.
  document.addEventListener('cn:compare-drawer-close', sync);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('storage', event => { if (event.key === null || event.key === key) schedule(); });
  window.visualViewport?.addEventListener('resize', schedule);
  mobile.addEventListener('change', schedule);
  new MutationObserver(records => { if (records.some(record => !bar.contains(record.target))) schedule(); }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'hidden', 'class', 'style', 'aria-hidden', 'aria-modal', 'data-state', 'data-cn-sticky-purchase-active'] });
  new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['style'] });
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(bar);
  sync();
})();
